// useBillFetch.ts
import { BillFetchPayload } from "features/bbps/biller/billerFlowTypes";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  billFetchRequested,
  billFetchReset,
} from "store/bbps/billFetch/billFetchSlice";
import { useAppDispatch } from "store/hooks";
import { RootState } from "store/rootReducer";

export function useBillFetch() {
  //const dispatch = useDispatch();
  const dispatch = useAppDispatch();
  const state = useSelector((s: RootState) => s.billFetch);

  const fetchBill = useCallback(
    (payload: BillFetchPayload) => {
      dispatch(billFetchRequested(payload));
    },
    [dispatch],
  );

  const reset = useCallback(() => {
    dispatch(billFetchReset());
  }, [dispatch]);

  return {
    ...state,
    fetchBill,
    reset,
  };
}
